import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../store/user-slice";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { notificationActions } from "../store/notification-slice";
import Backdrop from "./Backdrop";
import useAuthorized from "../hook/useAuthorized";
import Skeleton from "react-loading-skeleton";
import { useOrder } from "../hook/useOrder";
import AppNotification from "./AppNotification";
import RefreshContext from "../hook/RefreshContext";

export default function DefaultLayout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const refreshPending = useRef(false);
  const refreshHandler = useRef(null);
  const registerRefresh = useCallback(handler => {
    refreshHandler.current = handler;
    return () => {
      if (refreshHandler.current === handler) refreshHandler.current = null;
    };
  }, []);
  const refresh = useCallback(async () => {
    if (refreshPending.current) return;
    refreshPending.current = true;
    setRefreshing(true);
    try {
      const result = refreshHandler.current
        ? refreshHandler.current()
        : setRefreshKey(key => key + 1);
      await Promise.all([
        Promise.resolve(result),
        new Promise(resolve => setTimeout(resolve, 450)),
      ]);
    } finally {
      refreshPending.current = false;
      setRefreshing(false);
    }
  }, []);
  const refreshContext = useMemo(() => ({ registerRefresh, refresh, refreshing }), [registerRefresh, refresh, refreshing]);
  let dispatch = useDispatch();

  let navigate = useNavigate();
  const location = useLocation();

  let notification = useSelector((state) => state.notification.notification);

  const { isAdmin, isAuthorized } = useAuthorized();

  const {getCartItems}=useOrder()

 

  useEffect(() => {
    if (isAuthorized !== null && isAdmin !== null) {
      if (!isAuthorized) {
        dispatch(userActions.setUser(null));
        navigate("/login");
      }

      if (notification) {
        setTimeout(() => {
          dispatch(notificationActions.setNotification(null));
        }, 3000);
      }

      dispatch(userActions.setIsAdmin(isAdmin));
      
      getCartItems()
    }
  }, [notification, isAdmin, isAuthorized]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMobileMenuOpen) return undefined;
    const closeOnEscape = event => {
      if (event.key === "Escape") setIsMobileMenuOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [isMobileMenuOpen]);



  if (isAuthorized === null || isAdmin === null ) {
    return <Skeleton count={50} />;
  }

  return (
    <RefreshContext.Provider value={refreshContext}>
    <div className={`app-shell bg-maryam${isMobileMenuOpen ? " mobile-menu-open" : ""}`}>
      <Sidebar isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
      <button
        type="button"
        className="mobile-menu-backdrop"
        aria-label="Close navigation"
        onClick={() => setIsMobileMenuOpen(false)}
      />
      <div className="app-content">
        <Header onMenuToggle={() => setIsMobileMenuOpen(open => !open)} isMenuOpen={isMobileMenuOpen} />
        <main className="default-layout">
          <Outlet key={refreshKey} />
        </main>
      </div>

      <AppNotification notification={notification} aboveNavigation />

      <Backdrop />
    </div>
    </RefreshContext.Provider>
  );
}
